<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Stream Keyword Console</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label for=""><u>Filter by ShortCode</u></label>
        <ng-select [items]="shortCodeFilterList" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col-2">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Country" (ngModelChange)="changeKeyword($event)">
          <option value=null selected>All</option>
          <option *ngFor="let keyword of keywordList | keyvalue" [ngValue]="keyword">{{keyword.key}}</option>
        </select>
      </div>
      <div class="col-2">
        <label for=""><u>Filter by Operator</u></label>
        <select [(ngModel)]="filterable.operator" class="form-control" placeholder="Operator">
          <option value=null selected>All</option>
          <option *ngFor="let operator of operatorList" [value]="operator">{{operator}}</option>
        </select>
      </div>
      <div class="col-6 text-right align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
        <button class="btn btn-sm btn-outline-success text-dark font-weight-bold" (click)="openModal(newKeywordModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Keyword</button>

      </div>
    </div>
  </div>
</div>

<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="keywordList" class="table table-striped table-bordered mt-3" style="width:100%">
  <thead>
    <tr class="text-center">
      <th>No</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>Report Timezone</th>
      <th>Min</th>
      <th>Max</th>
      <th>Rate</th>
      <th>URL</th>
      <td>ReplacementPairs</td>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="15">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="15">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let keyword of keywords; index as i;" class="text-center">
      <td>{{i + 1}}</td>
      <td>{{keyword.shortCode}}</td>
      <td> {{keyword.keyword}}</td>
      <td>{{keyword.operator}}</td>
      <td>{{keyword.country}}</td>
      <td>{{keyword.min}}</td>
      <td>{{keyword.max}}</td>
      <td>{{keyword.rate}}</td>
      <td class="text-left">FullURL: {{keyword.url}}
        <br>CustomizedURL: {{keyword.customizedUrl}}
      </td>
      <td class="text-left">{{keyword.replacementPairs}}</td>
      <td>
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/stream/keyword-detail', keyword.id]" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteKeyword(keyword)"  *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="15" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newKeywordModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newKeywordLabel">New Keyword</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newKeyword-modal-body">
    <form [formGroup]="newKeywordForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-6">
          <label for="shortCode" class="col-form-label"><span class="text-danger">* </span>Short Code: </label>
          <input type="text" class="form-control" formControlName="shortCode" placeholder="Short Code">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.shortCode.errors">
              Short Code cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="keyword" class="col-form-label"><span class="text-danger">* </span>Keyword: </label>
          <input type="text" class="form-control" formControlName="keyword" placeholder="Keyword">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.keyword.errors">
              Keyword cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="operator" class="col-form-label"><span class="text-danger">* </span>Operator: </label>
          <input type="text" class="form-control" formControlName="operator" placeholder="Operator">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.operator.errors">
              Operator cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="country" class="col-form-label"><span class="text-danger">* </span>Report Time: </label>
          <select class="form-control" placeholder="Select" formControlName="country">
            <option value="">-select country-</option>
            <option *ngFor="let country of countryList" [ngValue]="country.code">{{country.name}}</option>
          </select>
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.country.errors">
              Country cannot be blank.
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <label for="min" class="col-form-label"><span class="text-danger">* </span>Min: </label>
          <input type="number" class="form-control" formControlName="min" placeholder="Min" min="0">
        </div>

        <div class="col-sm-6">
          <label for="max" class="col-form-label"><span class="text-danger">* </span>Max: </label>
          <input type="number" class="form-control" formControlName="max" placeholder="Max" min="0">
        </div>

        <div class="col-sm-6">
          <label for="rate" class="col-form-label"><span class="text-danger">* </span>Rate: </label>
          <input type="number" class="form-control" formControlName="rate" placeholder="Rate" min="0" max="100">
        </div>

        <div class="col-sm-6">
          <label for="url" class="col-form-label">Full URL: </label>
          <input type="text" class="form-control" formControlName="url" placeholder="URL">
        </div>

        <div class="col-sm-6">
          <label for="customizedUrl" class="col-form-label">Customized URL: </label>
          <input type="text" class="form-control" formControlName="customizedUrl" placeholder="Customized URL">
        </div>

        <div class="col-sm-6">
          <label for="replacementPairs" class="col-form-label">Replacement Pair: </label>
          <input type="text" class="form-control" formControlName="replacementPairs" placeholder='{"param1":"strVal","param2":1}'>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Keyword</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
